// ترجمات إضافية للصفحات الداخلية
export const additionalTranslations = {
  // ===== لوحة التحكم الإدارية =====
  'admin.title': {
    ar: 'لوحة تحكم المدير',
    en: 'Admin Dashboard',
    zh: '管理员控制面板'
  },
  'admin.statistics': {
    ar: 'إحصائيات عامة',
    en: 'General Statistics',
    zh: '一般统计'
  },
  'admin.totalClients': {
    ar: 'إجمالي العملاء',
    en: 'Total Clients',
    zh: '客户总数'
  },
  'admin.totalEmployees': {
    ar: 'إجمالي الموظفين',
    en: 'Total Employees',
    zh: '员工总数'
  },
  'admin.totalCases': {
    ar: 'إجمالي القضايا',
    en: 'Total Cases',
    zh: '案件总数'
  },
  'admin.activeCases': {
    ar: 'القضايا النشطة',
    en: 'Active Cases',
    zh: '活跃案件'
  },
  'admin.pendingRequests': {
    ar: 'الطلبات المعلقة',
    en: 'Pending Requests',
    zh: '待处理请求'
  },
  'admin.todayAppointments': {
    ar: 'مواعيد اليوم',
    en: "Today's Appointments",
    zh: '今日预约'
  },
  'admin.recentActivities': {
    ar: 'النشاطات الأخيرة',
    en: 'Recent Activities',
    zh: '最近活动'
  },
  'admin.quickActions': {
    ar: 'إجراءات سريعة',
    en: 'Quick Actions',
    zh: '快捷操作'
  },
  'admin.newClient': {
    ar: 'عميل جديد',
    en: 'New Client',
    zh: '新客户'
  },
  'admin.newCase': {
    ar: 'قضية جديدة',
    en: 'New Case',
    zh: '新案件'
  },
  'admin.newAppointment': {
    ar: 'موعد جديد',
    en: 'New Appointment',
    zh: '新预约'
  },
  'admin.viewReports': {
    ar: 'عرض التقارير',
    en: 'View Reports',
    zh: '查看报告'
  },

  // ===== بوابة العميل =====
  'portal.title': {
    ar: 'بوابة العميل',
    en: 'Client Portal',
    zh: '客户门户'
  },
  'portal.welcome': {
    ar: 'مرحباً بك',
    en: 'Welcome',
    zh: '欢迎'
  },
  'portal.myCases': {
    ar: 'قضاياي',
    en: 'My Cases',
    zh: '我的案件'
  },
  'portal.myRequests': {
    ar: 'طلباتي',
    en: 'My Requests',
    zh: '我的请求'
  },
  'portal.newConsultation': {
    ar: 'طلب استشارة جديدة',
    en: 'New Consultation Request',
    zh: '新咨询请求'
  },
  'portal.notaryServices': {
    ar: 'خدمات التوثيق',
    en: 'Notary Services',
    zh: '公证服务'
  },
  'portal.registerCase': {
    ar: 'تسجيل قضية جديدة',
    en: 'Register New Case',
    zh: '登记新案件'
  },
  'portal.urgentService': {
    ar: 'خدمة عاجلة',
    en: 'Urgent Service',
    zh: '紧急服务'
  },
  'portal.trackRequests': {
    ar: 'متابعة الطلبات',
    en: 'Track Requests',
    zh: '跟踪请求'
  },
  'portal.requestStatus': {
    ar: 'حالة الطلب',
    en: 'Request Status',
    zh: '请求状态'
  },
  'portal.requestDetails': {
    ar: 'تفاصيل الطلب',
    en: 'Request Details',
    zh: '请求详情'
  },
  'portal.submitRequest': {
    ar: 'تقديم طلب',
    en: 'Submit Request',
    zh: '提交请求'
  },

  // ===== القضايا =====
  'cases.title': {
    ar: 'إدارة القضايا',
    en: 'Case Management',
    zh: '案件管理'
  },
  'cases.caseNumber': {
    ar: 'رقم القضية',
    en: 'Case Number',
    zh: '案件编号'
  },
  'cases.caseType': {
    ar: 'نوع القضية',
    en: 'Case Type',
    zh: '案件类型'
  },
  'cases.caseStatus': {
    ar: 'حالة القضية',
    en: 'Case Status',
    zh: '案件状态'
  },
  'cases.clientName': {
    ar: 'اسم العميل',
    en: 'Client Name',
    zh: '客户名称'
  },
  'cases.lawyerAssigned': {
    ar: 'المحامي المسؤول',
    en: 'Assigned Lawyer',
    zh: '负责律师'
  },
  'cases.courtName': {
    ar: 'المحكمة',
    en: 'Court',
    zh: '法院'
  },
  'cases.filingDate': {
    ar: 'تاريخ القيد',
    en: 'Filing Date',
    zh: '立案日期'
  },
  'cases.nextSession': {
    ar: 'الجلسة القادمة',
    en: 'Next Session',
    zh: '下次开庭'
  },
  'cases.addCase': {
    ar: 'إضافة قضية',
    en: 'Add Case',
    zh: '添加案件'
  },
  'cases.editCase': {
    ar: 'تعديل القضية',
    en: 'Edit Case',
    zh: '编辑案件'
  },
  'cases.deleteCase': {
    ar: 'حذف القضية',
    en: 'Delete Case',
    zh: '删除案件'
  },
  'cases.viewDetails': {
    ar: 'عرض التفاصيل',
    en: 'View Details',
    zh: '查看详情'
  },
  'cases.active': {
    ar: 'نشطة',
    en: 'Active',
    zh: '活跃'
  },
  'cases.closed': {
    ar: 'مغلقة',
    en: 'Closed',
    zh: '已关闭'
  },
  'cases.pending': {
    ar: 'معلقة',
    en: 'Pending',
    zh: '待处理'
  },
  'cases.won': {
    ar: 'مكسوبة',
    en: 'Won',
    zh: '胜诉'
  },
  'cases.lost': {
    ar: 'خاسرة',
    en: 'Lost',
    zh: '败诉'
  },
  'cases.settled': {
    ar: 'تمت التسوية',
    en: 'Settled',
    zh: '已和解'
  },

  // ===== المواعيد =====
  'appointments.title': {
    ar: 'إدارة المواعيد',
    en: 'Appointment Management',
    zh: '预约管理'
  },
  'appointments.date': {
    ar: 'التاريخ',
    en: 'Date',
    zh: '日期'
  },
  'appointments.time': {
    ar: 'الوقت',
    en: 'Time',
    zh: '时间'
  },
  'appointments.client': {
    ar: 'العميل',
    en: 'Client',
    zh: '客户'
  },
  'appointments.type': {
    ar: 'نوع الموعد',
    en: 'Appointment Type',
    zh: '预约类型'
  },
  'appointments.location': {
    ar: 'الموقع',
    en: 'Location',
    zh: '地点'
  },
  'appointments.notes': {
    ar: 'ملاحظات',
    en: 'Notes',
    zh: '备注'
  },
  'appointments.addNew': {
    ar: 'إضافة موعد',
    en: 'Add Appointment',
    zh: '添加预约'
  },
  'appointments.upcoming': {
    ar: 'المواعيد القادمة',
    en: 'Upcoming Appointments',
    zh: '即将到来的预约'
  },
  'appointments.past': {
    ar: 'المواعيد السابقة',
    en: 'Past Appointments',
    zh: '过去的预约'
  },
  'appointments.today': {
    ar: 'مواعيد اليوم',
    en: "Today's Appointments",
    zh: '今日预约'
  },
  'appointments.consultation': {
    ar: 'استشارة',
    en: 'Consultation',
    zh: '咨询'
  },
  'appointments.courtSession': {
    ar: 'جلسة محكمة',
    en: 'Court Session',
    zh: '庭审'
  },
  'appointments.meeting': {
    ar: 'اجتماع',
    en: 'Meeting',
    zh: '会议'
  },
  'appointments.confirmed': {
    ar: 'مؤكد',
    en: 'Confirmed',
    zh: '已确认'
  },
  'appointments.cancelled': {
    ar: 'ملغي',
    en: 'Cancelled',
    zh: '已取消'
  },
  'appointments.rescheduled': {
    ar: 'تم إعادة الجدولة',
    en: 'Rescheduled',
    zh: '已重新安排'
  },

  // ===== الاستشارات =====
  'consultations.title': {
    ar: 'الاستشارات',
    en: 'Consultations',
    zh: '咨询'
  },
  'consultations.new': {
    ar: 'استشارة جديدة',
    en: 'New Consultation',
    zh: '新咨询'
  },
  'consultations.subject': {
    ar: 'الموضوع',
    en: 'Subject',
    zh: '主题'
  },
  'consultations.description': {
    ar: 'الوصف',
    en: 'Description',
    zh: '描述'
  },
  'consultations.response': {
    ar: 'الرد',
    en: 'Response',
    zh: '回复'
  },
  'consultations.pending': {
    ar: 'في انتظار الرد',
    en: 'Pending Response',
    zh: '等待回复'
  },
  'consultations.answered': {
    ar: 'تم الرد',
    en: 'Answered',
    zh: '已回复'
  },

  // ===== المستندات =====
  'documents.title': {
    ar: 'إدارة المستندات',
    en: 'Document Management',
    zh: '文件管理'
  },
  'documents.upload': {
    ar: 'رفع مستند',
    en: 'Upload Document',
    zh: '上传文件'
  },
  'documents.download': {
    ar: 'تحميل',
    en: 'Download',
    zh: '下载'
  },
  'documents.fileName': {
    ar: 'اسم الملف',
    en: 'File Name',
    zh: '文件名'
  },
  'documents.fileType': {
    ar: 'نوع الملف',
    en: 'File Type',
    zh: '文件类型'
  },
  'documents.fileSize': {
    ar: 'حجم الملف',
    en: 'File Size',
    zh: '文件大小'
  },
  'documents.uploadDate': {
    ar: 'تاريخ الرفع',
    en: 'Upload Date',
    zh: '上传日期'
  },
  'documents.category': {
    ar: 'التصنيف',
    en: 'Category',
    zh: '分类'
  },
  'documents.relatedCase': {
    ar: 'القضية المرتبطة',
    en: 'Related Case',
    zh: '相关案件'
  },

  // ===== العملاء =====
  'clients.title': {
    ar: 'إدارة العملاء',
    en: 'Client Management',
    zh: '客户管理'
  },
  'clients.addClient': {
    ar: 'إضافة عميل',
    en: 'Add Client',
    zh: '添加客户'
  },
  'clients.editClient': {
    ar: 'تعديل بيانات العميل',
    en: 'Edit Client',
    zh: '编辑客户'
  },
  'clients.clientInfo': {
    ar: 'معلومات العميل',
    en: 'Client Information',
    zh: '客户信息'
  },
  'clients.contactInfo': {
    ar: 'معلومات الاتصال',
    en: 'Contact Information',
    zh: '联系方式'
  },
  'clients.caseHistory': {
    ar: 'سجل القضايا',
    en: 'Case History',
    zh: '案件记录'
  },

  // ===== الموظفين =====
  'employees.title': {
    ar: 'إدارة الموظفين',
    en: 'Employee Management',
    zh: '员工管理'
  },
  'employees.addEmployee': {
    ar: 'إضافة موظف',
    en: 'Add Employee',
    zh: '添加员工'
  },
  'employees.editEmployee': {
    ar: 'تعديل بيانات الموظف',
    en: 'Edit Employee',
    zh: '编辑员工'
  },
  'employees.position': {
    ar: 'المنصب',
    en: 'Position',
    zh: '职位'
  },
  'employees.department': {
    ar: 'القسم',
    en: 'Department',
    zh: '部门'
  },
  'employees.joinDate': {
    ar: 'تاريخ الانضمام',
    en: 'Join Date',
    zh: '入职日期'
  },
  'employees.lawyer': {
    ar: 'محامي',
    en: 'Lawyer',
    zh: '律师'
  },
  'employees.consultant': {
    ar: 'مستشار',
    en: 'Consultant',
    zh: '顾问'
  },
  'employees.secretary': {
    ar: 'سكرتير',
    en: 'Secretary',
    zh: '秘书'
  },
  'employees.accountant': {
    ar: 'محاسب',
    en: 'Accountant',
    zh: '会计'
  },

  // ===== الفواتير =====
  'invoices.title': {
    ar: 'إدارة الفواتير',
    en: 'Invoice Management',
    zh: '发票管理'
  },
  'invoices.invoiceNumber': {
    ar: 'رقم الفاتورة',
    en: 'Invoice Number',
    zh: '发票编号'
  },
  'invoices.amount': {
    ar: 'المبلغ',
    en: 'Amount',
    zh: '金额'
  },
  'invoices.dueDate': {
    ar: 'تاريخ الاستحقاق',
    en: 'Due Date',
    zh: '到期日期'
  },
  'invoices.status': {
    ar: 'الحالة',
    en: 'Status',
    zh: '状态'
  },
  'invoices.paid': {
    ar: 'مدفوعة',
    en: 'Paid',
    zh: '已支付'
  },
  'invoices.unpaid': {
    ar: 'غير مدفوعة',
    en: 'Unpaid',
    zh: '未支付'
  },
  'invoices.overdue': {
    ar: 'متأخرة',
    en: 'Overdue',
    zh: '逾期'
  },
  'invoices.createInvoice': {
    ar: 'إنشاء فاتورة',
    en: 'Create Invoice',
    zh: '创建发票'
  },
  'invoices.sendInvoice': {
    ar: 'إرسال الفاتورة',
    en: 'Send Invoice',
    zh: '发送发票'
  },
  'invoices.printInvoice': {
    ar: 'طباعة الفاتورة',
    en: 'Print Invoice',
    zh: '打印发票'
  },

  // ===== الأتعاب =====
  'fees.title': {
    ar: 'إدارة الأتعاب',
    en: 'Fee Management',
    zh: '费用管理'
  },
  'fees.consultationFee': {
    ar: 'أتعاب الاستشارة',
    en: 'Consultation Fee',
    zh: '咨询费'
  },
  'fees.caseFee': {
    ar: 'أتعاب القضية',
    en: 'Case Fee',
    zh: '案件费'
  },
  'fees.additionalFee': {
    ar: 'رسوم إضافية',
    en: 'Additional Fee',
    zh: '附加费'
  },
  'fees.totalFees': {
    ar: 'إجمالي الأتعاب',
    en: 'Total Fees',
    zh: '总费用'
  },
  'fees.paidAmount': {
    ar: 'المبلغ المدفوع',
    en: 'Paid Amount',
    zh: '已付金额'
  },
  'fees.remainingAmount': {
    ar: 'المبلغ المتبقي',
    en: 'Remaining Amount',
    zh: '剩余金额'
  },

  // ===== الحضور والانصراف =====
  'attendance.title': {
    ar: 'الحضور والانصراف',
    en: 'Attendance',
    zh: '考勤'
  },
  'attendance.checkIn': {
    ar: 'تسجيل الحضور',
    en: 'Check In',
    zh: '签到'
  },
  'attendance.checkOut': {
    ar: 'تسجيل الانصراف',
    en: 'Check Out',
    zh: '签退'
  },
  'attendance.workHours': {
    ar: 'ساعات العمل',
    en: 'Work Hours',
    zh: '工作时间'
  },
  'attendance.lateArrivals': {
    ar: 'التأخيرات',
    en: 'Late Arrivals',
    zh: '迟到'
  },
  'attendance.absences': {
    ar: 'الغيابات',
    en: 'Absences',
    zh: '缺勤'
  },
  'attendance.present': {
    ar: 'حاضر',
    en: 'Present',
    zh: '在岗'
  },
  'attendance.absent': {
    ar: 'غائب',
    en: 'Absent',
    zh: '缺勤'
  },
  'attendance.late': {
    ar: 'متأخر',
    en: 'Late',
    zh: '迟到'
  },
  'attendance.onLeave': {
    ar: 'في إجازة',
    en: 'On Leave',
    zh: '休假'
  },

  // ===== الاجتماعات =====
  'meetings.title': {
    ar: 'إدارة الاجتماعات',
    en: 'Meeting Management',
    zh: '会议管理'
  },
  'meetings.newMeeting': {
    ar: 'اجتماع جديد',
    en: 'New Meeting',
    zh: '新会议'
  },
  'meetings.meetingTitle': {
    ar: 'عنوان الاجتماع',
    en: 'Meeting Title',
    zh: '会议标题'
  },
  'meetings.attendees': {
    ar: 'الحضور',
    en: 'Attendees',
    zh: '与会者'
  },
  'meetings.agenda': {
    ar: 'جدول الأعمال',
    en: 'Agenda',
    zh: '议程'
  },
  'meetings.minutes': {
    ar: 'محضر الاجتماع',
    en: 'Meeting Minutes',
    zh: '会议记录'
  },
  'meetings.joinMeeting': {
    ar: 'انضمام للاجتماع',
    en: 'Join Meeting',
    zh: '加入会议'
  },
  'meetings.startMeeting': {
    ar: 'بدء الاجتماع',
    en: 'Start Meeting',
    zh: '开始会议'
  },
  'meetings.endMeeting': {
    ar: 'إنهاء الاجتماع',
    en: 'End Meeting',
    zh: '结束会议'
  },

  // ===== التقارير =====
  'reports.title': {
    ar: 'التقارير',
    en: 'Reports',
    zh: '报告'
  },
  'reports.generate': {
    ar: 'إنشاء تقرير',
    en: 'Generate Report',
    zh: '生成报告'
  },
  'reports.caseReport': {
    ar: 'تقرير القضايا',
    en: 'Case Report',
    zh: '案件报告'
  },
  'reports.financialReport': {
    ar: 'تقرير مالي',
    en: 'Financial Report',
    zh: '财务报告'
  },
  'reports.attendanceReport': {
    ar: 'تقرير الحضور',
    en: 'Attendance Report',
    zh: '考勤报告'
  },
  'reports.performanceReport': {
    ar: 'تقرير الأداء',
    en: 'Performance Report',
    zh: '绩效报告'
  },
  'reports.dateRange': {
    ar: 'نطاق التاريخ',
    en: 'Date Range',
    zh: '日期范围'
  },
  'reports.export': {
    ar: 'تصدير',
    en: 'Export',
    zh: '导出'
  },
  'reports.print': {
    ar: 'طباعة',
    en: 'Print',
    zh: '打印'
  },

  // ===== المكتبة القانونية =====
  'library.title': {
    ar: 'المكتبة القانونية',
    en: 'Legal Library',
    zh: '法律图书馆'
  },
  'library.search': {
    ar: 'البحث في المكتبة',
    en: 'Search Library',
    zh: '搜索图书馆'
  },
  'library.categories': {
    ar: 'التصنيفات',
    en: 'Categories',
    zh: '分类'
  },
  'library.laws': {
    ar: 'القوانين',
    en: 'Laws',
    zh: '法律'
  },
  'library.regulations': {
    ar: 'الأنظمة',
    en: 'Regulations',
    zh: '法规'
  },
  'library.judgments': {
    ar: 'الأحكام القضائية',
    en: 'Court Judgments',
    zh: '法院判决'
  },
  'library.articles': {
    ar: 'المقالات القانونية',
    en: 'Legal Articles',
    zh: '法律文章'
  },
  'library.templates': {
    ar: 'النماذج والقوالب',
    en: 'Templates',
    zh: '模板'
  },

  // ===== المساعد القانوني الذكي =====
  'ai.title': {
    ar: 'المساعد القانوني الذكي',
    en: 'Legal AI Assistant',
    zh: '法律AI助手'
  },
  'ai.askQuestion': {
    ar: 'اطرح سؤالك',
    en: 'Ask your question',
    zh: '提出您的问题'
  },
  'ai.thinking': {
    ar: 'جاري التفكير...',
    en: 'Thinking...',
    zh: '思考中...'
  },
  'ai.response': {
    ar: 'الرد',
    en: 'Response',
    zh: '回复'
  },
  'ai.newChat': {
    ar: 'محادثة جديدة',
    en: 'New Chat',
    zh: '新对话'
  },
  'ai.history': {
    ar: 'سجل المحادثات',
    en: 'Chat History',
    zh: '对话记录'
  },
  'ai.disclaimer': {
    ar: 'هذه المعلومات للاسترشاد فقط وليست استشارة قانونية رسمية',
    en: 'This information is for guidance only and is not official legal advice',
    zh: '此信息仅供参考，不构成正式法律建议'
  },

  // ===== المحكمة الافتراضية =====
  'virtualCourt.title': {
    ar: 'المحكمة الافتراضية',
    en: 'Virtual Court',
    zh: '虚拟法庭'
  },
  'virtualCourt.selectRole': {
    ar: 'اختر دورك',
    en: 'Select Your Role',
    zh: '选择您的角色'
  },
  'virtualCourt.judge': {
    ar: 'القاضي',
    en: 'Judge',
    zh: '法官'
  },
  'virtualCourt.lawyer': {
    ar: 'المحامي',
    en: 'Lawyer',
    zh: '律师'
  },
  'virtualCourt.plaintiff': {
    ar: 'المدعي',
    en: 'Plaintiff',
    zh: '原告'
  },
  'virtualCourt.defendant': {
    ar: 'المدعى عليه',
    en: 'Defendant',
    zh: '被告'
  },
  'virtualCourt.witness': {
    ar: 'الشاهد',
    en: 'Witness',
    zh: '证人'
  },
  'virtualCourt.startSimulation': {
    ar: 'بدء المحاكاة',
    en: 'Start Simulation',
    zh: '开始模拟'
  },
  'virtualCourt.endSimulation': {
    ar: 'إنهاء المحاكاة',
    en: 'End Simulation',
    zh: '结束模拟'
  },
  'virtualCourt.score': {
    ar: 'النتيجة',
    en: 'Score',
    zh: '得分'
  },
  'virtualCourt.certificate': {
    ar: 'الشهادة',
    en: 'Certificate',
    zh: '证书'
  },
  'virtualCourt.games': {
    ar: 'الألعاب القانونية',
    en: 'Legal Games',
    zh: '法律游戏'
  },
  'virtualCourt.training': {
    ar: 'التدريب',
    en: 'Training',
    zh: '培训'
  },
  'virtualCourt.courtRace': {
    ar: 'سباق المحكمة',
    en: 'Court Race',
    zh: '法庭竞赛'
  },

  // ===== السندات =====
  'vouchers.title': {
    ar: 'إدارة السندات',
    en: 'Voucher Management',
    zh: '凭证管理'
  },
  'vouchers.receiptVoucher': {
    ar: 'سند قبض',
    en: 'Receipt Voucher',
    zh: '收据凭证'
  },
  'vouchers.paymentVoucher': {
    ar: 'سند صرف',
    en: 'Payment Voucher',
    zh: '付款凭证'
  },
  'vouchers.voucherNumber': {
    ar: 'رقم السند',
    en: 'Voucher Number',
    zh: '凭证编号'
  },
  'vouchers.amount': {
    ar: 'المبلغ',
    en: 'Amount',
    zh: '金额'
  },
  'vouchers.description': {
    ar: 'البيان',
    en: 'Description',
    zh: '说明'
  },
  'vouchers.createVoucher': {
    ar: 'إنشاء سند',
    en: 'Create Voucher',
    zh: '创建凭证'
  },

  // ===== البريد الإلكتروني =====
  'email.title': {
    ar: 'البريد الإلكتروني',
    en: 'Email',
    zh: '电子邮件'
  },
  'email.inbox': {
    ar: 'صندوق الوارد',
    en: 'Inbox',
    zh: '收件箱'
  },
  'email.sent': {
    ar: 'المرسلة',
    en: 'Sent',
    zh: '已发送'
  },
  'email.drafts': {
    ar: 'المسودات',
    en: 'Drafts',
    zh: '草稿'
  },
  'email.compose': {
    ar: 'رسالة جديدة',
    en: 'Compose',
    zh: '写邮件'
  },
  'email.reply': {
    ar: 'رد',
    en: 'Reply',
    zh: '回复'
  },
  'email.forward': {
    ar: 'إعادة توجيه',
    en: 'Forward',
    zh: '转发'
  },
  'email.delete': {
    ar: 'حذف',
    en: 'Delete',
    zh: '删除'
  },
  'email.subject': {
    ar: 'الموضوع',
    en: 'Subject',
    zh: '主题'
  },
  'email.to': {
    ar: 'إلى',
    en: 'To',
    zh: '收件人'
  },
  'email.from': {
    ar: 'من',
    en: 'From',
    zh: '发件人'
  },
  'email.attachments': {
    ar: 'المرفقات',
    en: 'Attachments',
    zh: '附件'
  },

  // ===== طلبات العملاء =====
  'requests.title': {
    ar: 'طلبات العملاء',
    en: 'Client Requests',
    zh: '客户请求'
  },
  'requests.requestId': {
    ar: 'رقم الطلب',
    en: 'Request ID',
    zh: '请求编号'
  },
  'requests.requestType': {
    ar: 'نوع الطلب',
    en: 'Request Type',
    zh: '请求类型'
  },
  'requests.requestDate': {
    ar: 'تاريخ الطلب',
    en: 'Request Date',
    zh: '请求日期'
  },
  'requests.status': {
    ar: 'الحالة',
    en: 'Status',
    zh: '状态'
  },
  'requests.underReview': {
    ar: 'قيد المراجعة',
    en: 'Under Review',
    zh: '审核中'
  },
  'requests.approved': {
    ar: 'موافق عليه',
    en: 'Approved',
    zh: '已批准'
  },
  'requests.rejected': {
    ar: 'مرفوض',
    en: 'Rejected',
    zh: '已拒绝'
  },
  'requests.referred': {
    ar: 'محال',
    en: 'Referred',
    zh: '已转交'
  },
  'requests.assignTo': {
    ar: 'إحالة إلى',
    en: 'Assign To',
    zh: '分配给'
  },
  'requests.viewDetails': {
    ar: 'عرض التفاصيل',
    en: 'View Details',
    zh: '查看详情'
  },
  'requests.updateStatus': {
    ar: 'تحديث الحالة',
    en: 'Update Status',
    zh: '更新状态'
  },
  'requests.addNote': {
    ar: 'إضافة ملاحظة',
    en: 'Add Note',
    zh: '添加备注'
  },

  // ===== خدمات التوثيق =====
  'notary.title': {
    ar: 'خدمات التوثيق',
    en: 'Notary Services',
    zh: '公证服务'
  },
  'notary.realEstate': {
    ar: 'عقارات',
    en: 'Real Estate',
    zh: '房地产'
  },
  'notary.powerOfAttorney': {
    ar: 'وكالات',
    en: 'Power of Attorney',
    zh: '授权书'
  },
  'notary.contracts': {
    ar: 'عقود',
    en: 'Contracts',
    zh: '合同'
  },
  'notary.wills': {
    ar: 'وصايا',
    en: 'Wills',
    zh: '遗嘱'
  },
  'notary.propertyType': {
    ar: 'نوع العقار',
    en: 'Property Type',
    zh: '财产类型'
  },
  'notary.transactionType': {
    ar: 'نوع المعاملة',
    en: 'Transaction Type',
    zh: '交易类型'
  },
  'notary.city': {
    ar: 'المدينة',
    en: 'City',
    zh: '城市'
  },
  'notary.details': {
    ar: 'التفاصيل',
    en: 'Details',
    zh: '详情'
  },

  // ===== تغيير كلمة المرور =====
  'password.title': {
    ar: 'تغيير كلمة المرور',
    en: 'Change Password',
    zh: '更改密码'
  },
  'password.current': {
    ar: 'كلمة المرور الحالية',
    en: 'Current Password',
    zh: '当前密码'
  },
  'password.new': {
    ar: 'كلمة المرور الجديدة',
    en: 'New Password',
    zh: '新密码'
  },
  'password.confirm': {
    ar: 'تأكيد كلمة المرور',
    en: 'Confirm Password',
    zh: '确认密码'
  },
  'password.requirements': {
    ar: 'يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل',
    en: 'Password must be at least 8 characters',
    zh: '密码必须至少8个字符'
  },
  'password.mismatch': {
    ar: 'كلمتا المرور غير متطابقتين',
    en: 'Passwords do not match',
    zh: '两次密码不一致'
  },
  'password.changed': {
    ar: 'تم تغيير كلمة المرور بنجاح',
    en: 'Password changed successfully',
    zh: '密码修改成功'
  },

  // ===== الرسائل العامة =====
  'msg.welcome': {
    ar: 'مرحباً بك',
    en: 'Welcome',
    zh: '欢迎'
  },
  'msg.goodbye': {
    ar: 'إلى اللقاء',
    en: 'Goodbye',
    zh: '再见'
  },
  'msg.noData': {
    ar: 'لا توجد بيانات',
    en: 'No data available',
    zh: '暂无数据'
  },
  'msg.noResults': {
    ar: 'لا توجد نتائج',
    en: 'No results found',
    zh: '未找到结果'
  },
  'msg.selectOption': {
    ar: 'اختر خياراً',
    en: 'Select an option',
    zh: '请选择'
  },
  'msg.required': {
    ar: 'هذا الحقل مطلوب',
    en: 'This field is required',
    zh: '此字段必填'
  },
  'msg.invalidEmail': {
    ar: 'البريد الإلكتروني غير صحيح',
    en: 'Invalid email address',
    zh: '邮箱格式不正确'
  },
  'msg.invalidPhone': {
    ar: 'رقم الهاتف غير صحيح',
    en: 'Invalid phone number',
    zh: '电话号码格式不正确'
  },
  'msg.fileTooLarge': {
    ar: 'حجم الملف يتجاوز الحد المسموح',
    en: 'File size exceeds the limit',
    zh: '文件大小超出限制'
  },
  'msg.unsupportedFormat': {
    ar: 'صيغة الملف غير مدعومة',
    en: 'File format not supported',
    zh: '不支持的文件格式'
  },
  'msg.uploadSuccess': {
    ar: 'تم رفع الملف بنجاح',
    en: 'File uploaded successfully',
    zh: '文件上传成功'
  },
  'msg.deleteConfirm': {
    ar: 'هل أنت متأكد من الحذف؟',
    en: 'Are you sure you want to delete?',
    zh: '确定要删除吗？'
  },
  'msg.actionCannotUndo': {
    ar: 'لا يمكن التراجع عن هذا الإجراء',
    en: 'This action cannot be undone',
    zh: '此操作无法撤销'
  },
  'msg.savedSuccessfully': {
    ar: 'تم الحفظ بنجاح',
    en: 'Saved successfully',
    zh: '保存成功'
  },
  'msg.operationFailed': {
    ar: 'فشلت العملية',
    en: 'Operation failed',
    zh: '操作失败'
  },
  'msg.tryAgain': {
    ar: 'يرجى المحاولة مرة أخرى',
    en: 'Please try again',
    zh: '请重试'
  },
  'msg.sessionExpired': {
    ar: 'انتهت صلاحية الجلسة',
    en: 'Session expired',
    zh: '会话已过期'
  },
  'msg.pleaseLogin': {
    ar: 'يرجى تسجيل الدخول',
    en: 'Please login',
    zh: '请登录'
  },
  'msg.accessDenied': {
    ar: 'الوصول مرفوض',
    en: 'Access denied',
    zh: '访问被拒绝'
  },
  'msg.comingSoon': {
    ar: 'قريباً',
    en: 'Coming Soon',
    zh: '即将推出'
  },
  'msg.underDevelopment': {
    ar: 'تحت التطوير',
    en: 'Under Development',
    zh: '开发中'
  },

  // ===== العملة =====
  'currency.sar': {
    ar: 'ريال سعودي',
    en: 'Saudi Riyal',
    zh: '沙特里亚尔'
  },
  'currency.symbol': {
    ar: 'ر.س',
    en: 'SAR',
    zh: 'SAR'
  },

  // ===== الوقت والتاريخ =====
  'time.today': {
    ar: 'اليوم',
    en: 'Today',
    zh: '今天'
  },
  'time.yesterday': {
    ar: 'أمس',
    en: 'Yesterday',
    zh: '昨天'
  },
  'time.tomorrow': {
    ar: 'غداً',
    en: 'Tomorrow',
    zh: '明天'
  },
  'time.thisWeek': {
    ar: 'هذا الأسبوع',
    en: 'This Week',
    zh: '本周'
  },
  'time.thisMonth': {
    ar: 'هذا الشهر',
    en: 'This Month',
    zh: '本月'
  },
  'time.thisYear': {
    ar: 'هذا العام',
    en: 'This Year',
    zh: '今年'
  },
  'time.ago': {
    ar: 'منذ',
    en: 'ago',
    zh: '前'
  },
  'time.minutes': {
    ar: 'دقائق',
    en: 'minutes',
    zh: '分钟'
  },
  'time.hours': {
    ar: 'ساعات',
    en: 'hours',
    zh: '小时'
  },
  'time.days': {
    ar: 'أيام',
    en: 'days',
    zh: '天'
  },

  // ===== أيام الأسبوع =====
  'day.sunday': {
    ar: 'الأحد',
    en: 'Sunday',
    zh: '星期日'
  },
  'day.monday': {
    ar: 'الاثنين',
    en: 'Monday',
    zh: '星期一'
  },
  'day.tuesday': {
    ar: 'الثلاثاء',
    en: 'Tuesday',
    zh: '星期二'
  },
  'day.wednesday': {
    ar: 'الأربعاء',
    en: 'Wednesday',
    zh: '星期三'
  },
  'day.thursday': {
    ar: 'الخميس',
    en: 'Thursday',
    zh: '星期四'
  },
  'day.friday': {
    ar: 'الجمعة',
    en: 'Friday',
    zh: '星期五'
  },
  'day.saturday': {
    ar: 'السبت',
    en: 'Saturday',
    zh: '星期六'
  },

  // ===== إدارة دوام الموظفين =====
  'schedule.title': {
    ar: 'إدارة دوام الموظفين',
    en: 'Employee Schedule Management',
    zh: '员工排班管理'
  },
  'schedule.schedulesTab': {
    ar: 'جداول الدوام',
    en: 'Schedules',
    zh: '排班表'
  },
  'schedule.attendanceTab': {
    ar: 'سجل الحضور',
    en: 'Attendance',
    zh: '考勤记录'
  },
  'schedule.reportsTab': {
    ar: 'التقارير',
    en: 'Reports',
    zh: '报告'
  },
  'schedule.employeesList': {
    ar: 'قائمة الموظفين',
    en: 'Employees List',
    zh: '员工列表'
  },
  'schedule.addNewSchedule': {
    ar: 'إضافة جدول جديد',
    en: 'Add New Schedule',
    zh: '添加新排班'
  },
  'schedule.searchEmployee': {
    ar: 'بحث عن موظف...',
    en: 'Search employee...',
    zh: '搜索员工...'
  },
  'schedule.filterAll': {
    ar: 'الكل',
    en: 'All',
    zh: '全部'
  },
  'schedule.filterWithSchedule': {
    ar: 'لديهم جدول',
    en: 'With Schedule',
    zh: '有排班'
  },
  'schedule.filterWithoutSchedule': {
    ar: 'بدون جدول',
    en: 'Without Schedule',
    zh: '无排班'
  },
  'schedule.noSchedule': {
    ar: 'لا يوجد جدول',
    en: 'No Schedule',
    zh: '无排班'
  },
  'schedule.selectEmployee': {
    ar: 'اختر الموظف',
    en: 'Select Employee',
    zh: '选择员工'
  },
  'schedule.selectEmployeePlaceholder': {
    ar: '-- اختر موظفاً --',
    en: '-- Select Employee --',
    zh: '-- 选择员工 --'
  },
  'schedule.allEmployeesHaveSchedules': {
    ar: 'جميع الموظفين لديهم جداول بالفعل',
    en: 'All employees already have schedules',
    zh: '所有员工已有排班'
  },
  'schedule.scheduleFor': {
    ar: 'جدول دوام',
    en: 'Schedule for',
    zh: '排班表'
  },
  'schedule.scheduleType': {
    ar: 'نوع الدوام',
    en: 'Schedule Type',
    zh: '排班类型'
  },
  'schedule.singleShift': {
    ar: 'دوام واحد',
    en: 'Single Shift',
    zh: '单班'
  },
  'schedule.singleShiftDesc': {
    ar: 'فترة عمل واحدة في اليوم',
    en: 'One work period per day',
    zh: '每天一个工作时段'
  },
  'schedule.doubleShift': {
    ar: 'دوامين',
    en: 'Double Shift',
    zh: '双班'
  },
  'schedule.doubleShiftDesc': {
    ar: 'فترتي عمل في اليوم',
    en: 'Two work periods per day',
    zh: '每天两个工作时段'
  },
  'schedule.firstShift': {
    ar: 'الدوام الأول',
    en: 'First Shift',
    zh: '第一班'
  },
  'schedule.secondShift': {
    ar: 'الدوام الثاني',
    en: 'Second Shift',
    zh: '第二班'
  },
  'schedule.startTime': {
    ar: 'وقت البدء',
    en: 'Start Time',
    zh: '开始时间'
  },
  'schedule.endTime': {
    ar: 'وقت الانتهاء',
    en: 'End Time',
    zh: '结束时间'
  },
  'schedule.workLocation': {
    ar: 'موقع العمل',
    en: 'Work Location',
    zh: '工作地点'
  },
  'schedule.enterAddress': {
    ar: 'أدخل اسم المدينة أو العنوان',
    en: 'Enter city name or address',
    zh: '输入城市名称或地址'
  },
  'schedule.latitude': {
    ar: 'خط العرض',
    en: 'Latitude',
    zh: '纬度'
  },
  'schedule.longitude': {
    ar: 'خط الطول',
    en: 'Longitude',
    zh: '经度'
  },
  'schedule.radius': {
    ar: 'النطاق (متر)',
    en: 'Radius (m)',
    zh: '范围（米）'
  },
  'schedule.showMap': {
    ar: 'عرض الخريطة',
    en: 'Show Map',
    zh: '显示地图'
  },
  'schedule.hideMap': {
    ar: 'إخفاء الخريطة',
    en: 'Hide Map',
    zh: '隐藏地图'
  },
  'schedule.selectedLocation': {
    ar: 'الموقع المحدد',
    en: 'Selected Location',
    zh: '已选位置'
  },
  'schedule.locationSet': {
    ar: 'تم تحديد الموقع',
    en: 'Location Set',
    zh: '已设置位置'
  },
  'schedule.workingDays': {
    ar: 'أيام العمل',
    en: 'Working Days',
    zh: '工作日'
  },
  'schedule.notificationSettings': {
    ar: 'إعدادات التنبيهات',
    en: 'Notification Settings',
    zh: '通知设置'
  },
  'schedule.enableNotifications': {
    ar: 'تفعيل التنبيهات',
    en: 'Enable Notifications',
    zh: '启用通知'
  },
  'schedule.checkoutReminder': {
    ar: 'تذكير الانصراف',
    en: 'Checkout Reminder',
    zh: '签退提醒'
  },
  'schedule.reminderBefore': {
    ar: 'التذكير قبل',
    en: 'Remind Before',
    zh: '提前提醒'
  },
  'schedule.notificationsOn': {
    ar: 'التنبيهات مفعلة',
    en: 'Notifications On',
    zh: '通知已开启'
  },
  'schedule.notificationsOff': {
    ar: 'التنبيهات معطلة',
    en: 'Notifications Off',
    zh: '通知已关闭'
  },
  'schedule.sendReminder': {
    ar: 'إرسال تذكير',
    en: 'Send Reminder',
    zh: '发送提醒'
  },
  'schedule.reminderTitle': {
    ar: 'تذكير بموعد العمل',
    en: 'Work Schedule Reminder',
    zh: '工作排班提醒'
  },
  'schedule.reminderMessage': {
    ar: 'يرجى الالتزام بموعد الدوام المحدد',
    en: 'Please adhere to your scheduled work time',
    zh: '请按时上班'
  },
  'schedule.reminderSent': {
    ar: 'تم إرسال التذكير إلى',
    en: 'Reminder sent to',
    zh: '提醒已发送给'
  },
  'schedule.noEmployeesFound': {
    ar: 'لم يتم العثور على موظفين',
    en: 'No employees found',
    zh: '未找到员工'
  },
  'schedule.attendanceRecords': {
    ar: 'سجلات الحضور',
    en: 'Attendance Records',
    zh: '考勤记录'
  },
  'schedule.employee': {
    ar: 'الموظف',
    en: 'Employee',
    zh: '员工'
  },
  'schedule.date': {
    ar: 'التاريخ',
    en: 'Date',
    zh: '日期'
  },
  'schedule.checkIn': {
    ar: 'وقت الحضور',
    en: 'Check In',
    zh: '签到时间'
  },
  'schedule.checkOut': {
    ar: 'وقت الانصراف',
    en: 'Check Out',
    zh: '签退时间'
  },
  'schedule.status': {
    ar: 'الحالة',
    en: 'Status',
    zh: '状态'
  },
  'schedule.present': {
    ar: 'حاضر',
    en: 'Present',
    zh: '出勤'
  },
  'schedule.late': {
    ar: 'متأخر',
    en: 'Late',
    zh: '迟到'
  },
  'schedule.absent': {
    ar: 'غائب',
    en: 'Absent',
    zh: '缺勤'
  },
  'schedule.noAttendanceRecords': {
    ar: 'لا توجد سجلات حضور',
    en: 'No attendance records',
    zh: '无考勤记录'
  },
  'schedule.attendanceWillAppear': {
    ar: 'ستظهر سجلات الحضور هنا عند تسجيل الموظفين',
    en: 'Attendance records will appear here when employees check in',
    zh: '员工签到后将在此显示考勤记录'
  },
  'schedule.reports': {
    ar: 'التقارير',
    en: 'Reports',
    zh: '报告'
  },
  'schedule.exportReport': {
    ar: 'تصدير التقرير',
    en: 'Export Report',
    zh: '导出报告'
  },
  'schedule.totalEmployees': {
    ar: 'إجمالي الموظفين',
    en: 'Total Employees',
    zh: '员工总数'
  },
  'schedule.activeSchedules': {
    ar: 'جداول نشطة',
    en: 'Active Schedules',
    zh: '活跃排班'
  },
  'schedule.withoutSchedule': {
    ar: 'بدون جدول',
    en: 'Without Schedule',
    zh: '无排班'
  },
  'schedule.notificationsActive': {
    ar: 'تنبيهات مفعلة',
    en: 'Notifications Active',
    zh: '通知已激活'
  },
  'schedule.days': {
    ar: 'أيام',
    en: 'days',
    zh: '天'
  },
  'schedule.noSchedulesYet': {
    ar: 'لا توجد جداول بعد',
    en: 'No schedules yet',
    zh: '暂无排班'
  },
  'time.minutes': {
    ar: 'دقيقة',
    en: 'minutes',
    zh: '分钟'
  },

  // ===== إعدادات الحساب =====
  'settings.accountSettings': {
    ar: 'إعدادات الحساب',
    en: 'Account Settings',
    zh: '账户设置'
  },
  'settings.profile': {
    ar: 'الملف الشخصي',
    en: 'Profile',
    zh: '个人资料'
  },
  'settings.changePassword': {
    ar: 'تغيير كلمة المرور',
    en: 'Change Password',
    zh: '修改密码'
  },
  'settings.uploadImage': {
    ar: 'رفع صورة',
    en: 'Upload Image',
    zh: '上传图片'
  },
  'settings.deleteImage': {
    ar: 'حذف الصورة',
    en: 'Delete Image',
    zh: '删除图片'
  },
  'settings.confirmDeleteImage': {
    ar: 'هل تريد حذف صورة البروفايل؟',
    en: 'Do you want to delete the profile image?',
    zh: '确定删除头像吗？'
  },
  'settings.imageUploaded': {
    ar: 'تم رفع الصورة بنجاح',
    en: 'Image uploaded successfully',
    zh: '图片上传成功'
  },
  'settings.imageDeleted': {
    ar: 'تم حذف الصورة بنجاح',
    en: 'Image deleted successfully',
    zh: '图片删除成功'
  },
  'settings.invalidImageType': {
    ar: 'نوع الملف غير مدعوم. يرجى رفع صورة (JPG, PNG, GIF, WEBP)',
    en: 'Invalid file type. Please upload an image (JPG, PNG, GIF, WEBP)',
    zh: '文件类型无效。请上传图片 (JPG, PNG, GIF, WEBP)'
  },
  'settings.imageTooLarge': {
    ar: 'حجم الصورة كبير جداً. الحد الأقصى 5MB',
    en: 'Image too large. Maximum size is 5MB',
    zh: '图片太大。最大5MB'
  },
  'settings.emailCannotChange': {
    ar: 'لا يمكن تغيير البريد الإلكتروني',
    en: 'Email cannot be changed',
    zh: '电子邮件无法更改'
  },
  'settings.currentPassword': {
    ar: 'كلمة المرور الحالية',
    en: 'Current Password',
    zh: '当前密码'
  },
  'settings.newPassword': {
    ar: 'كلمة المرور الجديدة',
    en: 'New Password',
    zh: '新密码'
  },
  'settings.confirmNewPassword': {
    ar: 'تأكيد كلمة المرور الجديدة',
    en: 'Confirm New Password',
    zh: '确认新密码'
  },
  'settings.passwordMismatch': {
    ar: 'كلمة المرور الجديدة غير متطابقة',
    en: 'New passwords do not match',
    zh: '新密码不匹配'
  },
  'settings.passwordTooShort': {
    ar: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
    en: 'Password must be at least 6 characters',
    zh: '密码至少6个字符'
  },
  'settings.passwordMinLength': {
    ar: 'يجب أن تكون 6 أحرف على الأقل',
    en: 'Must be at least 6 characters',
    zh: '至少6个字符'
  },
  'settings.passwordChanged': {
    ar: 'تم تغيير كلمة المرور بنجاح',
    en: 'Password changed successfully',
    zh: '密码修改成功'
  },

  // ===== حقول النماذج =====
  'form.email': {
    ar: 'البريد الإلكتروني',
    en: 'Email',
    zh: '电子邮件'
  },
  'form.fullName': {
    ar: 'الاسم الكامل',
    en: 'Full Name',
    zh: '全名'
  },
  'form.phone': {
    ar: 'رقم الجوال',
    en: 'Phone Number',
    zh: '电话号码'
  },
  'form.password': {
    ar: 'كلمة المرور',
    en: 'Password',
    zh: '密码'
  },

  // ===== اجتماعات الفيديو =====
  'meetings.videoMeetings': {
    ar: 'اجتماعات الفيديو',
    en: 'Video Meetings',
    zh: '视频会议'
  },
  'meetings.instantMeetingAll': {
    ar: 'اجتماع فوري للجميع',
    en: 'Instant Meeting for All',
    zh: '全员即时会议'
  },
  'meetings.callAllEmployees': {
    ar: 'دعوة جميع الموظفين الآن',
    en: 'Call all employees now',
    zh: '立即呼叫所有员工'
  },
  'meetings.instantMeetingSelect': {
    ar: 'اجتماع فوري',
    en: 'Instant Meeting',
    zh: '即时会议'
  },
  'meetings.selectParticipants': {
    ar: 'اختر المشاركين',
    en: 'Select Participants',
    zh: '选择参与者'
  },
  'meetings.scheduleMeeting': {
    ar: 'جدولة اجتماع',
    en: 'Schedule Meeting',
    zh: '安排会议'
  },
  'meetings.planFutureMeeting': {
    ar: 'تحديد موعد لاحق',
    en: 'Plan a future meeting',
    zh: '安排未来会议'
  },
  'meetings.activeMeetings': {
    ar: 'اجتماعات نشطة',
    en: 'Active Meetings',
    zh: '进行中的会议'
  },
  'meetings.scheduledMeetings': {
    ar: 'اجتماعات مجدولة',
    en: 'Scheduled Meetings',
    zh: '已安排的会议'
  },
  'meetings.history': {
    ar: 'السجل',
    en: 'History',
    zh: '历史记录'
  },
  'meetings.noActiveMeetings': {
    ar: 'لا توجد اجتماعات نشطة حالياً',
    en: 'No active meetings currently',
    zh: '目前没有进行中的会议'
  },
  'meetings.startNewMeeting': {
    ar: 'ابدأ اجتماعاً جديداً من الأزرار أعلاه',
    en: 'Start a new meeting using the buttons above',
    zh: '使用上面的按钮开始新会议'
  },
  'meetings.join': {
    ar: 'انضم',
    en: 'Join',
    zh: '加入'
  },
  'meetings.start': {
    ar: 'ابدأ',
    en: 'Start',
    zh: '开始'
  },
  'meetings.title': {
    ar: 'عنوان الاجتماع',
    en: 'Meeting Title',
    zh: '会议标题'
  },
  'meetings.participants': {
    ar: 'المشاركون',
    en: 'Participants',
    zh: '参与者'
  },
  'meetings.allEmployees': {
    ar: 'جميع الموظفين',
    en: 'All Employees',
    zh: '所有员工'
  },
  'meetings.dateTime': {
    ar: 'التاريخ والوقت',
    en: 'Date & Time',
    zh: '日期和时间'
  },
  'meetings.duration': {
    ar: 'المدة (دقيقة)',
    en: 'Duration (minutes)',
    zh: '时长（分钟）'
  },
  'meetings.notes': {
    ar: 'ملاحظات',
    en: 'Notes',
    zh: '备注'
  },
  'meetings.notesPlaceholder': {
    ar: 'أضف ملاحظات أو جدول الأعمال...',
    en: 'Add notes or agenda...',
    zh: '添加备注或议程...'
  },
  'meetings.startNow': {
    ar: 'ابدأ الآن',
    en: 'Start Now',
    zh: '立即开始'
  },
  'meetings.schedule': {
    ar: 'جدولة',
    en: 'Schedule',
    zh: '安排'
  },
  'meetings.instantMeeting': {
    ar: 'اجتماع فوري',
    en: 'Instant Meeting',
    zh: '即时会议'
  },
  'meetings.noScheduledMeetings': {
    ar: 'لا توجد اجتماعات مجدولة',
    en: 'No scheduled meetings',
    zh: '没有已安排的会议'
  },
  'meetings.noHistory': {
    ar: 'لا يوجد سجل اجتماعات',
    en: 'No meeting history',
    zh: '没有会议记录'
  },

  // ===== لوحة الموظف =====
  'staff.title': {
    ar: 'لوحة الموظف',
    en: 'Staff Dashboard',
    zh: '员工控制面板'
  },
  'staff.myTasks': {
    ar: 'المهام المُسندة إليك',
    en: 'Tasks Assigned to You',
    zh: '分配给您的任务'
  },
  'staff.totalTasks': {
    ar: 'إجمالي المهام',
    en: 'Total Tasks',
    zh: '任务总数'
  },
  'staff.completed': {
    ar: 'مكتملة',
    en: 'Completed',
    zh: '已完成'
  },
  'staff.pending': {
    ar: 'قيد الانتظار',
    en: 'Pending',
    zh: '待处理'
  },
  'staff.overdue': {
    ar: 'متأخرة',
    en: 'Overdue',
    zh: '逾期'
  },
  'staff.completionRate': {
    ar: 'نسبة الإنجاز',
    en: 'Completion Rate',
    zh: '完成率'
  },
  'staff.daily': {
    ar: 'يومي',
    en: 'Daily',
    zh: '每日'
  },
  'staff.weekly': {
    ar: 'أسبوعي',
    en: 'Weekly',
    zh: '每周'
  },
  'staff.monthly': {
    ar: 'شهري',
    en: 'Monthly',
    zh: '每月'
  },
  'staff.noTasksToday': {
    ar: 'لا توجد مهام لهذا اليوم',
    en: 'No tasks for today',
    zh: '今天没有任务'
  },
  'staff.noTasksWeek': {
    ar: 'لا توجد مهام لهذا الأسبوع',
    en: 'No tasks for this week',
    zh: '本周没有任务'
  },
  'staff.noTasksMonth': {
    ar: 'لا توجد مهام لهذا الشهر',
    en: 'No tasks for this month',
    zh: '本月没有任务'
  },
  'staff.markComplete': {
    ar: 'تحديد كمكتمل',
    en: 'Mark as Complete',
    zh: '标记为完成'
  },
  'staff.viewDetails': {
    ar: 'عرض التفاصيل',
    en: 'View Details',
    zh: '查看详情'
  },
  'staff.inProgress': {
    ar: 'جاري العمل',
    en: 'In Progress',
    zh: '进行中'
  },
  'staff.assignedTask': {
    ar: 'مهمة محالة',
    en: 'Assigned Task',
    zh: '分配的任务'
  },
  'staff.changeStatus': {
    ar: 'تغيير الحالة',
    en: 'Change Status',
    zh: '更改状态'
  },
  'staff.taskDetails': {
    ar: 'تفاصيل المهمة',
    en: 'Task Details',
    zh: '任务详情'
  },

  // ===== البريد الداخلي =====
  'email.internalMail': {
    ar: 'البريد الداخلي',
    en: 'Internal Mail',
    zh: '内部邮件'
  },
  'email.inbox': {
    ar: 'صندوق الوارد',
    en: 'Inbox',
    zh: '收件箱'
  },
  'email.sent': {
    ar: 'المرسل',
    en: 'Sent',
    zh: '已发送'
  },
  'email.drafts': {
    ar: 'المسودات',
    en: 'Drafts',
    zh: '草稿'
  },
  'email.starred': {
    ar: 'المميزة',
    en: 'Starred',
    zh: '已加星标'
  },
  'email.trash': {
    ar: 'المهملات',
    en: 'Trash',
    zh: '垃圾箱'
  },
  'email.compose': {
    ar: 'رسالة جديدة',
    en: 'Compose',
    zh: '写邮件'
  },

  // ===== خدمات الشركات =====
  'services.consultation': {
    ar: 'استشارة قانونية',
    en: 'Legal Consultation',
    zh: '法律咨询'
  },
  'services.case': {
    ar: 'قضية قانونية',
    en: 'Legal Case',
    zh: '法律案件'
  },
  'services.contract': {
    ar: 'صياغة عقود',
    en: 'Contract Drafting',
    zh: '合同起草'
  },
  'services.notary': {
    ar: 'خدمات التوثيق',
    en: 'Notary Services',
    zh: '公证服务'
  },
  'services.establishment': {
    ar: 'تأسيس شركات',
    en: 'Company Establishment',
    zh: '公司注册'
  },
  'services.legalAdvisor': {
    ar: 'مستشار قانوني دوري',
    en: 'Periodic Legal Advisor',
    zh: '定期法律顾问'
  },

  // ===== بوابات الدفع =====
  'payment.selectMethod': {
    ar: 'اختر طريقة الدفع',
    en: 'Select Payment Method',
    zh: '选择支付方式'
  },
  'payment.sadad': {
    ar: 'سداد',
    en: 'SADAD',
    zh: 'SADAD支付'
  },
  'payment.mada': {
    ar: 'مدى',
    en: 'Mada Card',
    zh: 'Mada卡'
  },
  'payment.applePay': {
    ar: 'Apple Pay',
    en: 'Apple Pay',
    zh: 'Apple Pay'
  },
  'payment.confirmOrder': {
    ar: 'تأكيد الطلب',
    en: 'Confirm Order',
    zh: '确认订单'
  },
};

export default additionalTranslations;
